// removed by extract-text-webpack-plugin
module.exports = {"statusBar":"CentricUI__ToolsPanel__StatusBar__statusBar","left":"CentricUI__ToolsPanel__StatusBar__left","right":"CentricUI__ToolsPanel__StatusBar__right","section":"CentricUI__ToolsPanel__StatusBar__section"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/whiteboard/components/ToolsPanel/StatusBar.css
// module id = 1276
// module chunks = 10